import Image from "next/image";
import dayjs from "dayjs";
import Link from "next/link";
import quote from "@/public/images/quote.png";
import avisVerifiesLogo from "@/public/images/avisVerifiesLogo.png";
import { Review } from "@/interfaces/Review";
import { routes } from "@/routes/routes";
import { StarsRating } from "../ratingInStars/StarsRating";
import styles from "./MainReviewBlock.module.scss";

export const MainReviewBlock = ({
  text,
  date,
  author,
  agencyName,
  agencySlug,
  rating,
}: Review) => (
  <div className={styles.mainReviewContainer}>
    <StarsRating rating={rating} starSize={27} spacing={12} />
    <p className={styles.reviewText}>« {text} »</p>
    <p className={styles.reviewAuthor}>
      {`${author}. (${dayjs(date).tz("Europe/Paris").format("DD/MM/YYYY")})`}
    </p>
    <Link href={routes.agencyPage(agencySlug)}>
      <a className={styles.reviewAgency}>{agencyName}</a>
    </Link>

    <div className={styles.avisVerifiesImageWrapper}>
      <Image src={avisVerifiesLogo} alt="" layout="fill" />
    </div>

    <div className={styles.quoteImageContainer}>
      <div className={styles.quoteImageWrapper}>
        <Image src={quote} alt="" layout="fill" />
      </div>
    </div>
  </div>
);
